export const feedDataPerDate = (original, daySpan, dateKey, keys) => {
  const data = [...original]
  let start = new Date()
  start.setDate(start.getDate() - daySpan)

  const end = new Date()
  while (start <= end) {
    const dateString = start.toISOString().split('T')[0]
    if (original.find(item => item[dateKey] === dateString)) {
      start.setDate(start.getDate() + 1)
      continue
    }
    const newObject = {}
    newObject[dateKey] = dateString
    keys.forEach(key => {
      newObject[key] = 0
    })
    newObject[dateKey] = dateString
    newObject['timestamp'] = new Date(dateString)

    data.push(newObject)

    start.setDate(start.getDate() + 1)
  }

  return data
}
